<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable width="900px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          <div v-if="announce">{{ $t("NewUpdate.announ3") }}</div>
          <div v-else>{{ $t("onechat.consentlist") }}</div>
          <v-spacer></v-spacer>
          <v-btn outlined color="error" @click="Fn_Close()">
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <v-card-text class="pa-2">
          <v-stepper v-model="StatusBtn" class="rounded-lg elevation-0">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0">
                <v-card-actions v-if="SelectRole" class="mt-n1">
                  <v-layout
                    row
                    wrap
                    justify-end
                    align-center
                    :justify-center="$vuetify.breakpoint.smAndDown"
                    pa-2
                  >
                    <v-flex
                      xs11
                      sm8
                      md8
                      lg8
                      mr-5
                      justify-end
                      text-right
                      v-if="SelectNameAccount.length > 0"
                    >
                      <b
                        >{{ $t("NewUpdate.Allname") }}
                        <v-chip class="ma-1 white--text" color="#077893">
                          {{ filteredData.length }}
                        </v-chip>
                        {{ $t("consentlist.list") }}</b
                      >
                    </v-flex>
                    <v-flex xs3 md2 lg2>
                      <v-btn
                        rounded
                        block
                        dark
                        color="#077893"
                        @click="Fn_NextPage"
                        :disabled="SelectRole == ''"
                      >
                        {{ $t("onechat.next") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
                <v-card-text class="pa-0">
                  <v-form ref="formConsent" v-model="valid" lazy-validation>
                    <v-layout row wrap justify-center pt-2 pb-2>
                      <v-flex xs11 md4 lg4>
                        <b class="red--text mr-1">*</b>
                        <b>{{ $t("onechat.text1") }}</b>
                        <v-select
                          :loading="loadingDownloadData"
                          dense
                          :items="ItemsDepartment"
                          :label="$t('onechat.text2')"
                          :disabled="TypeSent === 'SentAll'"
                          :rules="[(v) => !!v || $t('onechat.text2')]"
                          item-text="DepartmentName"
                          return-object
                          v-model="SelectDepartment"
                          item-value="DepartmentId"
                          outlined
                        >
                        </v-select>
                      </v-flex>
                      <v-flex lg1 md11 xs9 sm9></v-flex>
                      <v-flex xs11 lg4 md4>
                        <b class="red--text mr-1">*</b>
                        <b>{{ $t("onechat.text3") }}</b>
                        <v-select
                          dense
                          return-object
                          :items="ItemsRole"
                          :label="
                            ItemsRole.length === 0
                              ? 'ไม่พบข้อมูลตำแหน่ง'
                              : $t('onechat.text4')
                          "
                          :disabled="DisabledPosition"
                          v-model="SelectRole"
                          item-text="RoleName"
                          item-value="RoleId"
                          :rules="[(v) => !!v || $t('onechat.text4')]"
                          outlined
                        >
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-2">
                <v-card-actions>
                  <v-layout row wrap justify-space-between align-center pa-2>
                    <v-flex xs11 sm3 md2 lg2>
                      <v-btn
                        block
                        dark
                        rounded
                        color="#077893"
                        @click="StatusBtn = 1"
                      >
                        {{ $t("onechat.back") }}
                      </v-btn>
                    </v-flex>
                    <v-flex xs11 sm7 md7 lg7 justify-end text-right>
                      <b
                        >{{ $t("NewUpdate.Allname") }}
                        <v-chip class="ma-1 white--text" color="#077893">
                          {{ filteredData.length }}
                        </v-chip>
                        {{ $t("consentlist.list") }}</b
                      >
                    </v-flex>
                    <v-flex xs11 sm3 md2 lg2>
                      <v-btn
                        :disabled="dis"
                        block
                        rounded
                        dark
                        color="#077893"
                        :loading="LoadingSentConsent"
                        @click="Fn_Save(SelectNameAccount)"
                      >
                        <!-- @click="Fn_Save(SelectNameAccount)" -->
                        {{ $t("email.text7") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
                <v-card outlined class="mt-2">
                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-layout row wrap justify-center align-center pt-3 pb-3>
                        <v-flex xs12 lg12 md12>
                          <v-data-table
                            :headers="headers"
                            v-model="SelectNameAccount"
                            :items="ItemsPosition"
                            item-key="AccountId"
                            show-select
                            hide-default-footer
                            :loading="btnSendLoading"
                            :page.sync="Page"
                            @page-count="PageCount = $event"
                            loading-text="กำลังดาวน์โหลดข้อมูล..."
                            :items-per-page="ItemPerPage"
                          >
                            <template v-slot:[`item.NameTh`]="{ item }">
                              {{ item.TitleNameTh }} {{ item.NameTh }}
                            </template>
                            <template v-slot:[`item.NameEng`]="{ item }">
                              {{ item.TitleNameEng }} {{ item.NameEng }}
                            </template>
                          </v-data-table>
                          <v-pagination
                            :total-visible="7"
                            class="pt-2 pb-2"
                            circle
                            color="#077893"
                            v-model="Page"
                            :length="PageCount"
                            prev-icon="mdi-menu-left"
                            next-icon="mdi-menu-right"
                          >
                          </v-pagination>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
                <div class="red--text mt-2">
                  <b
                    >หมายเหตุ​ : หากต้องการเลือกรายชื่อเพิ่มเติม
                    ให้กดกลับเพื่อทำรายการอีกครั้ง</b
                  >
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <DialogCheckUser
        :show="DialogList"
        :_detail="ItemsCheckUser"
        :_payload="payloadUserOnechat"
        @closeDialogDelete="DialogList = false"
      />
    </div>
  </v-row>
</template>
<script>
import DialogCheckUser from "@/components/dialog/ConsentOnechat/DialogConsentCheckUserOnechat.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogCheckUser },
  props: ["show", "_detail", "announce"],
  data: function () {
    return {
      loadingDownloadData: false,
      btnSendLoading: true,
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      valid: true,
      ExpirationDate: "",
      DisabledPosition: false,
      SelectNameAccount: [],
      TypeSent: "",
      LoadingSentConsent: false,
      StatusBtn: 1,
      ItemsRole: [],
      ItemsDepartment: [
        // {
        //   BusinessId: '00000',
        //   DepartmentId: '00000',
        //   DepartmentName: this.$i18n.t('onechat.all1')
        // }
      ],
      ItemsPosition: [],
      SelectDepartment: "",
      SelectRole: "",
      dis: false,
      disDialog2: false,
      ViewData: [],
      ItemsCheckUser: [],
      DialogList: false,
      payloadUserOnechat: {},
    };
  },
  created() {},
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "no",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameTh"),
            value: "NameTh",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameEng"),
            value: "NameEng",
            sortable: false,
          },
        ];
      },
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.StatusBtn = 1;
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.ItemsDepartment = [];
        this.ItemsPosition = [];
        this.SelectNameAccount = [];
        this.Fn_GetDepartment();
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        // this.DepartmentId = '00000'
        this.DisabledPosition = true;
      } else if (val.Role.length >= 1) {
        this.ItemsRole = val.Role;
        this.DisabledPosition = false;
      } else {
        this.SelectRole = "";
        // this.DepartmentId = '00000'
        this.DisabledPosition = true;
      }
    },
    SelectRole(val) {
      this.ItemsPosition = val.Account;
      this.btnSendLoading = false;
      /// // ฟังค์ชันสำหรับ เพิ่มลำดับลงในข้อมูล /////
      var index = 0;
      for (var item of this.ItemsPosition) {
        index += 1;
        item.no = index;
      }
    },
    SelectNameAccount(val) {
      if (val.length == 0) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
  },
  mounted() {},
  methods: {
    async BackToAdd() {
      this.StatusBtn = 1;
    },
    async Fn_GetDepartment() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        TaxId: this._SelectTaxId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/department/role/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.loadingDownloadData = false;
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsDepartment.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    Fn_NextPage() {
      this.StatusBtn = 2;
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_Save(val) {
      // this.$emit("closeDialog");
      // this.$emit("confirmAccount", val);
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.$emit("closeDialog");
        this.$emit("confirmAccount", val);
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      }
    },
    async Fn_CheckUserOnechat() {
      for (var i in this.SelectNameAccount) {
        delete this.SelectNameAccount[i].Email;
        delete this.SelectNameAccount[i].Mobile;
      }
      if (this._DataGroupOneChatSearch.Type === "General") {
        this.SelectConsentGeneral =
          this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
        this.SelectConsentGroup = "";
      } else if (this._DataGroupOneChatSearch.Type === "Group") {
        this.SelectConsentGeneral = "";
        this.SelectConsentGroup =
          this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
      }
      this.payloadUserOnechat = {
        UserName: this.$cookies.get("OneUsername"),
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.SelectNameAccount,
        ConsentGroupId: this.SelectConsentGroup,
        Consent: this.SelectConsentGeneral,
        PolicyId: this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId,
        UserId: this.$cookies.get("OneAccountId"),
        GroupSend: this._DataGroupOneChatSearch.Detail.GroupSend,
        ShowPolicy: true,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/CheckUserOneChatConsent",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.DialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Close() {
      this.ItemsRole = [];
      this.SelectNameAccount = [];
      this.ItemsDepartment = [];
      this.ItemsPosition = [];
      this.$emit("closeDialog");
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}

.row.no-gutters {
  display: flex;
  align-items: center;
}
</style>
